export enum EPlatform {
    ACC = "acc",
    BIM360 = "bim360"
}
  